import { render } from "./Newsletter.vue?vue&type=template&id=1de4f408"
import script from "./Newsletter.vue?vue&type=script&lang=js"
export * from "./Newsletter.vue?vue&type=script&lang=js"
script.render = render

export default script